/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { FETCH_ACES_FI_CHAP_APPLIED } from './actionTypes';

import { fetchAcesFiChapAppliedUtil } from './utils';

/**
 * Contains the action creator functions that update the ACESFI slice of the store.
 *
 * @namespace ACESFIActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/aces_fi_chap_applied
   *
   * @param {any} callback function to call once this function has finished
   * @function
   * @memberof ACESFIActions
   */
  static fetchAcesFiChapApplied = (dispatch, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      fetchAcesFiChapAppliedUtil,
      FETCH_ACES_FI_CHAP_APPLIED,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to fetchAcesFiChapApplied.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof ACESFIActions
   */
  static resetFetchAcesFiChapApplied = (dispatch, data) => {
    const json = {
      type: FETCH_ACES_FI_CHAP_APPLIED.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to fetchAcesFiChapApplied.
   *
   * @param {function} dispatch
   * @function
   * @memberof ACESFIActions
   */
  static resetFetchAcesFiChapAppliedError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, FETCH_ACES_FI_CHAP_APPLIED.failureAction);
  };
}
